import styled from 'styled-components';
import Text from './Text';
var Underlined = styled(Text).attrs(function (_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'span' : _ref$as;
  return {
    as: as
  };
}).withConfig({
  displayName: "Underlined",
  componentId: "sc-rsi22d-0"
})(["text-decoration:underline;"]);
export default Underlined;